'use strict';

import jQuery from 'jquery';
import cookie from './../../vendor/jquery.cookie';
import serializeObject from './../../vendor/jquery.serialize-object.2.5.0';
import Core from './../Core/Core';
import Donation from './donation.js';
import DonationFormModel from './donationFormModel.js';
import rivets from 'rivets';
import ga from './../../vendor/google-analytics';
import fbq from './../../vendor/facebook-pixel';
import Utilities from './../Utilities/Utilities.js';
import dtd from './doubleTheDonation.js';
import flag from '../Feature/Feature';

/**
 * Code for custom donation forms
 */
(function ($) {
  $(document).ready(function ($) {

    // Initialize the core Donation Engine code
    Donation.init();

    // Create references to key page elements
    var $donationFromWrapper = $('.donation-form-wrapper'),
      $donationForm = $('#donation-form'),
      $donationFormContent = $('#donation-form-content'),
      $paymentType = $('#payment-type-area'),
      $gifts = $('.gift-source'),
      $giftQuantities = $('.gift-quantity'),
      $popularAmounts = $('.donation-amount'),
      $otherAmountInputField = $('.other-amount'),
      $reviewButton = $('.review-donation'),
      $thankYou = $('#finished-content'),
      $oneTimeAmountOptions = $('.onetime-options input'),
      $sustainingAmountOptions = $('.sustaining-options input'),
      $otherAmount = $('.other-amount');

    // Define the state cookie for this form
    var FORM_STATE_COOKIE = location.pathname.replace(/\//g, '') + '-pageStateId';

    // Define the rivets formatter for basic appending
    rivets.formatters.append = function append(data, base) {
      return base + data;
    };

    // Define the rivets formatter that transforms gift ids to existence booleans
    rivets.formatters.isInOrder = function isInOrder(gifts, id) {
      return gifts.reduce(
        function (matchedId, gift) {
          return matchedId || (gift.id === id);
        },
        false
      );
    };

    // Define the rivets formatter for monetary values
    rivets.formatters.monetary = Core.utils.formatAsMoney;

    // Define the rivets formatter for masking credit cards
    rivets.formatters.creditcard = function maskCreditCard(card) {

      // Make sure the card is a string so it can be pattern matched on
      var cardNumber = '' + card;

      return cardNumber.replace(/[0-9](?=([0-9]{4}))/g, '*');
    };

    rivets.formatters.creditcardSelection = function creditcardSelection(id) {
      return 'card-type' + (id ? ' ' + id + '-selection' : '');
    };

    rivets.formatters.equals = function equalsValue(a, b) {
      return a === b;
    };

    let PaymentOptions = {
      Checking: "#checking-option",
      Credit: "#credit-card-option",
      Paypal: "#paypal-option"
    };

    // Define a base empty model for this form
    var model = {};

    /**
     * Initializes the donation form by attaching the event handlers, fetching
     * the existing user state from the server, and then finally binding the
     * donation form model to the UI
     */
    function init(options) {

      // Decode any encoded fields
      if (typeof options !== 'undefined') {

        // Decode anything that was provided as encoding
        if (typeof options.decode !== 'undefined') {
          Donation.decode(options.decode);
        }
      }

      // Once decoding has been completed, create the base model
      model = createFormModel();

      Donation.isOneTimeFunc = function () {
        return model.order.isOnetime();
      };

      // Set up the DTD pledge function.
      dtd.pledgeTotalFunc = getModelPledgeTotal;

      // Attach the form handlers
      attachEventHandlers();

      // If there is a state cookie, try to load a user state from it
      if (typeof $.cookie(FORM_STATE_COOKIE) !== 'undefined') {

        // Try to get any previously existing state for the user from the server
        // and load it in to the form
        Donation.getState($.cookie(FORM_STATE_COOKIE)).
          then(
            function (data) {
              try {

                // Start by trying to parse the user's returned state
                var stateModel = JSON.parse(data);

                // Make sure that the version of the state model matches the
                // version of the form that the user is on
                if (stateModel.version === model.version) {

                  // Transfer the state into the model
                  stateModel = $.extend(true, model, JSON.parse(data));

                  // Go through the gift list and restore gift quantities to the form
                  stateModel.order.gifts.forEach(function (gift) {

                    // Look up the gift element in the UI, and extract the quantity input
                    var $gift = $donationForm.find('[data-gift-id="' + gift.id + '"]'),
                      $quantityInput = $gift.find('.gift-quantity');

                    // Update the quantity input so that it has the appropriate data
                    $quantityInput.val(gift.quantity);
                  });

                  // Now that the gift elements are up to date, rebuild the gift list
                  // properly with full data
                  stateModel.order.gifts = getGiftState();

                  // Finally overwrite the base model with the state model
                  model = stateModel;

                  // Check the appropriate amount, if one was selected.
                  if (model.order.popularAmounts[model.order.path] !== 0) {
                    if (model.order.path === 'sustaining') {
                      selectAppropriateAmount($sustainingAmountOptions);
                    } else {
                      selectAppropriateAmount($oneTimeAmountOptions);
                    }
                  }

                  if (typeof options !== 'undefined') {

                    if (typeof options.payPalStatus !== 'undefined' && options.payPalStatus) {

                      if (options.payPalStatus === 'done') {
                        handleTransactionSuccess();
                      } else if (options.payPalStatus === 'cancelled') {
                        $('.paypal-cancelled-message').show();
                      } else {
                        $('.paypal-failed-message').show();
                      }
                    }
                  }
                }
              } catch (e) {
                console.log('Error with getState server request. Failed to parse state.');
              }
            },
            function (data, textStatus) {

              // If there was a failure to communicate with the server, display it
              Core.utils.dialog('<div>Error with getState server request: ' + textStatus + '</div>');
            }
          ).
          always(
            function () {

              // No matter if the server returned back a previous user state, set up the state.
              setUpInitialState();
            }
          );
      } else {

        // If there is not a state cookie, set up the state.
        setUpInitialState();
      }

      // Start donation tracking
      fbq('track', 'InitiateCheckout');
    }

    /**
     * Sets up the state when there is none.
     */
    function setUpInitialState() {
      var binding = rivets.bind($donationForm.get(), { "model": model });
      initializePathAmounts();
      $donationFromWrapper.fadeIn();
      window.m = model;

      let loadInfo = Donation.getMemberInfo();

      const changeSelection = (e) => {
        e.preventDefault();
        e.stopPropagation();

        let button = e && e.target && e.target.closest("button");

        let paymentMethod = button.dataset.paymentMethod;

        model.user.payment.selection = paymentMethod;

        switch (paymentMethod) {
          case 'cc':
            if (model.user.payment.hasExistingCreditData && model.user.payment.useExistingData) {
              $("#cc-existing-checkbox").focus();
            } else {
              $("#payment-charge-card-number").focus();
            }

            break;
          case 'checking':
            if (model.user.payment.hasExistingEFTData && model.user.payment.useExistingData) {
              $("#eft-existing-checkbox").focus();
            } else {
              $("#payment-eft-routing-number").focus();
            }
            break;
          case 'paypal':
            // Nothing to select for PayPal
            break;
        }

        Donation.clearValidationErrors();
      };

      $(PaymentOptions.Checking).click(changeSelection);
      $(PaymentOptions.Credit).click(changeSelection);
      $(PaymentOptions.Paypal).click(changeSelection);

      if (loadInfo) {
        loadInfo.then(function (data) {
          // FIXME: Don't use dom + publish to do this, update the model directly. Requires changes in Donation.getMemberInfo()

          binding.publish();

          // This code is severely broken and bad. This is a hack to work around multiple issues.
          // Reset the selected path back to the default path
          if ($('.path-btn').length > 0) {
            model.order.path = $('.path-btn')[0].value;
          }

          function changeToUpdateEFTOrCredit(e) {
            e.preventDefault();

            model.user.payment.useExistingData = false;
          }

          function cancelUpdateEFTOrCreditChange(e) {
            e.preventDefault();

            model.user.payment.useExistingData = true;

            // Clear any potential inputs
            $("#payment-charge-card-cvv").val("");
            $("#payment-charge-card-number").val("");
            $("#payment-eft-routing-number").val("");
            $("#payment-eft-account-number").val("");
          }

          // Add event listeners
          $("#add-new-card").click(changeToUpdateEFTOrCredit);
          $("#update-existing-card").click(changeToUpdateEFTOrCredit);
          $("#cancel-card-change").click(cancelUpdateEFTOrCreditChange);

          $("#add-new-eft").click(changeToUpdateEFTOrCredit);
          $("#update-existing-eft").click(changeToUpdateEFTOrCredit);
          $("#cancel-eft-change").click(cancelUpdateEFTOrCreditChange);

          if (data && data.account && data.account.sustaining_amount) {
            model.user.account.current_sustaining = data.account.sustaining_amount;
          }

          // Determine if we have enough payment info to show the option to pay with
          // an existing method.
          let canUseExistingPaymentMethod = flag('use_existing_payment') &&
            data &&
            data.account &&
            data.account.is_sustainer &&
            data.features &&
            data.features.use_existing_payment;

          if (canUseExistingPaymentMethod) {
            if (data.account.is_cc) {
              if (data.account.cc_last_4 && data.account.cc_issuer && data.account.exp_month && data.account.exp_year) {
                model.user.payment.hasExistingCreditData = true;

                model.user.account.last_four = data.account.cc_last_4;
                model.user.payment.credit.expiration.month = data.account.exp_month;

                // Need to handle 2 and 4 digit years
                if (`${data.account.exp_year}`.length === 4) {
                  model.user.payment.credit.expiration.year = parseInt(`${data.account.exp_year}`.slice(2));
                } else {
                  model.user.payment.credit.expiration.year = data.account.exp_year;
                }

                model.user.payment.selection = 'cc';
                model.user.payment.useExistingData = true;
              }
            }
            else if (data.account.is_eft) {
              if (data.account.account_num_last_4) {
                model.user.payment.hasExistingEFTData = true;

                model.user.account.last_four = data.account.account_num_last_4;

                model.user.payment.selection = 'checking';
                model.user.payment.useExistingData = true;
              }
            }
          } else {
            // Default
            model.user.payment.selection = 'checking';
          }

        });
      }
    }

    /**
     * Selects the appropriate amount in one of the amount options
     *
     * @param {jQuery) $options
     */
    function selectAppropriateAmount($options) {
      $options.each(function (i, el) {
        var $el = $(el);

        if ($el.val() === model.order.popularAmounts[model.order.path]) {
          $el.attr('checked', 'checked');
          return;
        }
      });
    }

    /**
     * Creates the base model.
     *
     * @return {DonationFormModel}
     */
    function createFormModel() {
      // Try to extract the MVault token from the DOM
      var mvaultToken = $('#mvault-token-message').attr('data-token');

      var model = new DonationFormModel({
        version: $('#donation-form-version').val(),
        order: {
          path: $('input[name="path"]').eq(0).val(),
        },
        user: {
          billing: {
            fname: $('#fname').val(),
            lname: $('#lname').val(),
            email: $('#email').val(),
            member_id: $('#member-id').val()
          },
          payment: {
            selection: $('.payment-type-option-selection').eq(0).val()
            // selection: ID_TO_PAYMENT_TYPE_MAP[$paymentType.find("input[type='radio']").first().attr("id")]
          },
          passport: {
            token: typeof mvaultToken !== 'undefined' ? mvaultToken : ''
          }
        }
      });

      // Set up minimum donation vars if they've been defined for the form.
      // If empty, default to 5.

      model.order.minimumSustainingDonationEnforced = $('#minimum-sustaining-enforced').val() || false;
      model.order.minimumOneTimeDonationEnforced = $('#minimum-onetime-enforced').val() || false;
      model.order.minimumSustainingDonation = $('#minimum-sustaining-amount').val() || Donation.PLEDGE_MIN;
      model.order.minimumOneTimeDonation = $('#minimum-onetime-amount').val() || Donation.PLEDGE_MIN;
      model.order.minimumDonationCustomMessage = $('#minimum-donation-message').val();

      // If there is only one gift and it isn't sold out, it's already part of the order.
      if ($gifts.length === 1) {
        var $gift = $gifts.eq(0);

        if ($gift.find('.gift-quantity').length !== 0) {

          // It's not sold out.  Add it.
          model.order.addGift(getGiftFromDOM($gift));
        }
      }

      return model;
    }

    /**
     * Replaces the target elements value with and empty string if it is
     * currently zero
     *
     * @param {jQuery.event} $event
     */
    function clearOutZeroQuantity($event) {
      var $this = $($event.currentTarget);

      if (parseInt($this.val(), 10) === 0) {
        $this.val('');
      }
    }

    /**
     * Updates all gift input fields that have empty strings for values with a
     * zero value
     *
     * @param {jQuery.event} $event
     */
    function restoreZeroQuantity($event) {

      // Restore zero values for gifts that have no quantity
      var $this = $($event.currentTarget);

      if ($this.val() === '') {
        $this.val(0);
      }
    }

    /**
     * Define a function that will extract the gift objects from the UI that
     * represent the gifts that the user is ordering, including their quantity
     *
     * @returns {Array} An array of gift objects representing a users gift
     *                  selections, including their quantities
     */
    function getGiftState() {

      // Collect up the gifts and filter out those with non-positive quantities
      return $gifts.
        filter(function (index, gift) {
          var quantity = $(gift).find('.gift-quantity').val();
          return quantity === '' || quantity > 0;
        }).
        map(function (index, gift) {
          return getGiftFromDOM($(gift));
        }).
        get();
    }

    /**
     * Builds a gift object from it's jQuery representation
     *
     * @param {jQuery} $gift
     * @return {object}
     */
    function getGiftFromDOM($gift) {

      // Get the jQuery object for ease, and extract the gift metadata,
      // and the gift quantities.
      // jQuery extend is used here to get the gift metadata because we
      // want a copy of the data object to manipulate
      var giftMeta = $.extend(true, {}, $gift.data('meta'));

      giftMeta.quantity = $gift.find('.gift-quantity').val();

      // Return the update gift metadata
      return giftMeta;
    }

    /**
     * Tries to save the donation form state back to the server so the user can
     * resume their session for a limited period of time. After saving the
     * state, the state id returned from the server is stored to a cookie unique
     * to this donation form
     *
     * @returns {*|Promise.<T>}
     */
    function saveDonationState() {

      // Send it to the server.
      return Donation.saveState('id=' + model.id + '&data=' + JSON.stringify(model.getSaveState())).
        then(
          function (data) {

            // If data is returned, it is the cookie ID.  Store it.
            if (model.id === '') {
              model.id = data;

              var dateToSet = new Date();
              dateToSet.setMinutes(dateToSet.getMinutes() + 30);

              return $.cookie(
                FORM_STATE_COOKIE,
                model.id,
                {
                  expires: dateToSet,
                  path: '/'
                }
              );
            }
          },
          function (data, textStatus) {
            // Core.utils.dialog('<div>Error with saveState server request: ' + textStatus + '</div>');
            console.log('Error with saveState server request');
          }
        );
    }


    function creditCardExpired() {
      if (model.user.payment.selection === "cc" && model.user.payment.useExistingData) {
        let year = model.user.payment.credit && model.user.payment.credit.expiration && model.user.payment.credit.expiration.year;
        let month = model.user.payment.credit && model.user.payment.credit.expiration && model.user.payment.credit.expiration.month;

        if (year && month) {
          try {
            let expiration = new Date(`${month}/01/${year}`);
            let today = new Date();
            if (expiration < today) {
              return true;
            }
          }
          catch (_) {
            // failed to parse date
          }
        }
      }

      return false;
    }

    /**
     * Attempts to transition the user to the review section of the donation
     * form. Succeeds if the donation form validates, and will fail with
     * validation messages if not.
     */
    function moveToReview() {

      // Check to make sure that the user has pledge at least the minimum
      // amount for a valid pledge

      if (!model.order.meetsHardMinimum()) {

        // If they did not pledge enough, notify them with a popup
        let $message = '<div>' + model.order.minimumDonationMessage() + '</div>';
        Core.utils.dialog($message);
      } else {

        if (creditCardExpired()) {
          Donation.validateAllAreas();
          return;
        }

        // Next check to make sure that all fields on the form are valid
        if ($donationForm.valid()) {

          // If everything looks good, start by removing the review button
          // from the form. Any future updates will simply update immediately
          $reviewButton.hide();

          // Fade in the review section of the form
          $('.review-order-section').fadeIn();
        } else {

          // If validation does not passed, display the relevant validation
          // error messages
          Donation.validateAllAreas();
        }
      }
    }

    /**
     * Makes an attempt at submitting the donation form. Handles extracting the
     * data from the form inputs and then augmenting it with computed values
     * based on the model representing the form. After building the submission
     * data, the data is sent over to the general donation transaction
     * processing method.
     *
     * @returns {Promise.<T>|null} Returns either a promise for the form
     *                             submission or null if the form failed when
     *                             trying to validate
     */
    function processDonationForm() {
      // Make sure that the donation form is valid before trying to submit
      if ($donationForm.valid()) {

        // Now that the form has been validated, start the submission process
        // by extracting a JSON object of the form data
        var formData = $donationForm.serializeObject();

        // Override the payment method with "existing" if the user has opted to
        // use their existing payment method for the selected method
        if (model.user.payment.isExistingCredit() || model.user.payment.isExistingEFT()) {
          formData.payment_type = 'existing';
        }

        // Define the default transaction type for the submission
        formData.transaction_type = 'donation';

        // Define the return URL
        formData.custom_return_url = window.location.href;

        // Update the shipping field with the computed total for the order
        formData.shipping = '' + model.order.shippingTotal();

        // Update the list of gift ids in the submission so that they match
        // appropriately with the users selections
        formData.gift_id = model.order.gifts.map(
          function (gift) {
            return gift.id;
          }
        );

        // Update the list of gift quantities in the submission so that they
        // match appropriately with the users selections
        formData.gift_quantity = model.order.gifts.map(
          function (gift) {
            return gift.quantity;
          }
        );

        // Update the one time donation flag to properly reflect the form path
        formData.is_one_time = '' + model.order.isOnetime();

        // Update the single amount fields based on the form path
        if (model.order.isOnetime()) {
          formData.one_time_popular_amounts = model.order.onetimeTotal();
          formData.one_time_other_amount = model.order.onetimeTotal();
          formData.no_gift_additional_pledge_amount = model.order.singleAdditionalAmount;
        } else {
          formData.monthly_amount = model.order.singleTotal();
          formData.additional_pledge_monthly_amount = model.order.singleAdditionalAmount;
        }

        // Finally send the submission off ot the processing piece
        return Donation.processTransaction(formData);
      } else {

        // If validation does not passed, display the relevant validation
        // error messages
        Donation.validateAllAreas();
      }

      return null;
    }

    /**
     * Handles events after a successful transaction has returned us to the form
     */
    function handleTransactionSuccess() {

      // Destroy the state cookie
      $.removeCookie(FORM_STATE_COOKIE, { path: '/' });

      // Hide the intro text and the donation form
      $('.donation-form-intro').hide();
      $donationFormContent.addClass('hide');

      // Scroll the user to the top
      $(window).scrollTop(0);

      // Display the thank you message
      $thankYou.fadeIn();
    }


    /**
     * Attach the event handlers that are used for the donation form
     */
    function attachEventHandlers() {

      // Validate company on donation change.
      $('.pledge-form-section input').change(function (e) {
        dtd.validateCompany();
      });

      // Social (Facebook, Twitter and Email)
      $('.socials').on(
        'click',
        '.social-share',
        Core.utils.onSocialShare
      );

      $('.path-btn').click(function (e) {
        $('.free-option-content').hide();
        $('.giving-option-content').show();
      });

      $('#free-registration-option').click(function (e) {
        $('.free-option-content').show();
        $('.giving-option-content').hide();
      });

      // Attach the handler for toggling the more/less information link that
      // displays and hides the full gift description
      $('.search-description-toggle').on(
        'click',
        Donation.moreLinkClick
      );

      // Popular amounts and other amount are mutually exclusive. When one
      // changes the other should default to empty
      $popularAmounts.on(
        'change',
        function () {
          if ($(this).val() > 0) {
            model.order.singleOtherAmount = '';
          }
        }
      );

      // Popular amounts and other amount are mutually exclusive. When one
      // changes the other should default to empty
      $otherAmountInputField.on(
        'click',
        function () {
          model.order.popularAmounts.sustaining = model.order.popularAmounts.onetime = 0;
        }
      );

      // Define and attach the handler that updates the orders gift list based
      // on interactions with the gift quantity inputs. A lot of data depends
      // on this list, so the updates are debounced to reduce the amount of
      // computation that is required to run
      $giftQuantities.on(
        'change keyup blur',
        Core.utils.debounce(function () {

          // Update the model with the currently selected gifts

          // Start by splicing away the full gift list. This will reset the list
          model.order.resetGifts();

          // Then get the list representation of the gift order, and for each
          // one, push it on to the gift order list
          getGiftState().forEach(function (gift) {
            model.order.addGift(gift);
          });

          dtd.validateCompany();
        }, 128)
      );

      $('.add-to-order').on(
        'click',
        function addItemToOrder($event) {
          $event.preventDefault();
          $(this).parents('.gift').find('.gift-quantity').val(1).trigger('change');
        }
      );

      // Attach the handler that replaces empty quantity inputs with a zero
      $giftQuantities.on(
        'blur',
        restoreZeroQuantity
      );

      // Attach the handlers that clears out the zero digit when a user focuses
      // on a quantity input that has a zero in it
      $giftQuantities.on(
        'focus',
        clearOutZeroQuantity
      );

      // Attach the handler that transitions the user to the final step of the
      // donation process
      $reviewButton.on(
        'click',
        function moveToDonationReview($event) {

          $event.preventDefault();

          // Try to save the donation state to the server. Do not pause the code
          // for this to happen, and if it fails, simply continue on
          saveDonationState();

          // Try to move the user to the review section
          moveToReview();
        }
      );

      // Attach the form processing handler that takes care of doing the form submission logic
      $('.submit-donation-form-btn').on(
        'click',
        function ($event) {

          $event.preventDefault();

          // Try processing the donation form
          var process = processDonationForm();

          // If process is not null, then a transaction attempt was made
          if (process !== null) {

            // Chain off the process to handling display the final form messages
            process.then(
              function (response) {

                // Check to make sure the server responded successfully
                if (response && response.result === 'success') {

                  // Add the MVault token to the users thank you message if it
                  // exists in the response
                  if (typeof response.mvaultToken !== 'undefined' && response.mvaultToken !== '') {
                    model.user.passport.token = response.mvaultToken;
                  }

                  // Add the Passport activation requirement to the users status
                  // if it exists in the response. Not all users that qualify
                  // for Passport actually need to activate their account
                  if (typeof response.passportActivationRequired !== 'undefined') {
                    model.user.passport.passportActivationRequired = response.passportActivationRequired;
                  }

                  // Destroy the state cookie
                  $.removeCookie(FORM_STATE_COOKIE, { path: '/' });

                  var trackingTotal = model.order.isSustaining() ? model.order.sustainingTotal() * 12 : model.order.onetimeTotalWithShipping();

                  // Send the event to Google about the total.
                  ga(
                    'send',
                    'event',
                    'Online donations',
                    model.order.isSustaining() ? 'Monthly' : 'One-time',
                    Core.utils.buildTrackingURL($('head').attr('data-tracking')) + ' | ' + $('#pledge-code-override').val(),
                    trackingTotal
                  );

                  ga(
                    'send',
                    'event',
                    'Online donations payment type',
                    (model.order.isSustaining() ? 'Monthly' : 'One-time') + ' | ' + model.user.payment.humanPaymentType(),
                    Core.utils.buildTrackingURL($('head').attr('data-tracking')) + ' | ' + $('#pledge-code-override').val(),
                    trackingTotal
                  );

                  var xactionId = Utilities.weakUuid();
                  ga(
                    'ecommerce:addTransaction', {
                    'id': xactionId,
                    'affiliation': '',
                    'revenue': model.order.isOnetime() ? model.order.onetimeTotal() : model.order.sustainingTotal,
                    'shipping': model.order.shippingTotal()
                  }
                  );
                  model.order.gifts.forEach(function (gift) {
                    ga(
                      'ecommerce:addItem', {
                      'id': xactionId,
                      'sku': gift.id,
                      'name': gift.title,
                      'category': '',
                      'price': model.order.isOnetime() ? gift.price.onetime : gift.price.sustaining,
                      'quantity': gift.quantity
                    }
                    );
                  });
                  ga('ecommerce:send');

                  // Track the event to Facebook
                  fbq(
                    'track',
                    'Purchase',
                    {
                      currency: 'USD',
                      content_name: 'Custom Form Donation',
                      trackingTotal
                    }
                  );

                  // Hide the intro text and the donation form
                  $('.donation-form-intro').hide();
                  $donationFormContent.addClass('hide');

                  // Scroll the user to the top
                  $(window).scrollTop(0);

                  handleTransactionSuccess();
                }
              }
            );
          }
        }
      );

      // Select the corresponding option in the other set of amounts if one is selected.
      $('.path-btn').each(function (i, el) {
        var $el = $(el);

        $el.click(function (i, el) {
          model.order.popularAmounts.sustaining = model.order.popularAmounts.onetime = 0;

          // Can't rely on the model to be set here because it isn't set yet.  Set it manually.
          model.order.path = $el.hasClass('sustaining-path-btn') ? 'sustaining' : 'onetime';

          initializePathAmounts();
        });
      });
    }

    /**
     * Potentially sets it to the first amount if there is only the hidden option.
     */
    function initializePathAmounts() {

      // If there is only one amount for this path and there is no other amount, set the value based
      // on the hidden radio button.
      if ($otherAmount.length === 0) {
        if (model.order.path === 'sustaining') {
          if ($sustainingAmountOptions.length === 1) {
            model.order.popularAmounts.sustaining = $sustainingAmountOptions.eq(0).val();
          }
        } else {
          if ($oneTimeAmountOptions.length === 1) {
            model.order.popularAmounts.onetime = $oneTimeAmountOptions.eq(0).val();
          }
        }
      }
    }

    /**
     * Gets the pledge total for DTD.
     *
     * @return {float}
     */
    function getModelPledgeTotal() {
      let total = model.order.pledgeTotal();

      // The pledge total for sustaining doesn't account for the full year. Make it.
      if (model.order.isSustaining()) {
        total *= 12;
      }

      return total;
    }

    // Run the donation form initialization process
    init(window.supportOptions);
  });
})(jQuery);

export default {}